import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { runDevAudit } from './auditTranslations';

import en from './locales/en.json';
import de from './locales/de.json';
import es from './locales/es.json';
import pt from './locales/pt-BR.json';
import fr from './locales/fr.json';
import ar from './locales/ar.json';
import ru from './locales/ru.json';
import hr from './locales/hr.json';

export const languages = [
  { code: 'en', name: 'English (UK)', flag: '🇬🇧', dir: 'ltr' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪', dir: 'ltr' },
  { code: 'es', name: 'Español', flag: '🇪🇸', dir: 'ltr' },
  { code: 'pt-BR', name: 'Português (BR)', flag: '🇧🇷', dir: 'ltr' },
  { code: 'fr', name: 'Français', flag: '🇫🇷', dir: 'ltr' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦', dir: 'rtl' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺', dir: 'ltr' },
  { code: 'hr', name: 'Hrvatski', flag: '🇭🇷', dir: 'ltr' },
] as const;

// Track missing keys in development
const missingKeys: Set<string> = new Set();

export const getMissingKeys = () => Array.from(missingKeys);
export const clearMissingKeys = () => missingKeys.clear();

const resources = {
  en: { translation: en },
  'en-GB': { translation: en },
  'en-US': { translation: en },
  de: { translation: de },
  es: { translation: es },
  'pt-BR': { translation: pt },
  pt: { translation: pt },
  fr: { translation: fr },
  ar: { translation: ar },
  ru: { translation: ru },
  hr: { translation: hr },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ['en', 'en-GB', 'en-US', 'de', 'es', 'pt-BR', 'pt', 'fr', 'ar', 'ru', 'hr'],
    load: 'languageOnly', // en-GB/en-US -> en
    fallbackLng: {
      'en-GB': ['en'],
      'en-US': ['en'],
      default: ['en'],
    },
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: (_lngs, _ns, key) => {
      if (import.meta.env.DEV) {
        missingKeys.add(key);
      }
    },
  });

// Run i18n audit in development
runDevAudit(resources);

export default i18n;

